const tabs = document.querySelectorAll(".footer__block-heading");
const mobileDevice = window.matchMedia("(width < 575px)");

const tabsHandler = (device) => {
  if (device.matches) {
    console.log("INOVA US");

    tabs.forEach((tab) => {
      tab.addEventListener("click", () => {
        tab.classList.toggle("footer__tab--active");
      });
    });
  }
}

mobileDevice.addEventListener("change", tabsHandler);

tabsHandler(mobileDevice);
